import { createSlice } from "@reduxjs/toolkit";
import { httpGet, httpPost } from "../../util/Rest";
import { ACCOUNT_STATUS, IMPORTANT_NOTES, PATIENT_DEMOGRAPHICS } from "../../util/Content";
import { fetchAccountStatus } from "./AccountStatus";
import { getSpecNotes } from "./SpecNotes";
import { fetchCommunicationOptOutsData, fetchCustomerDemographics } from "./CustomerDemographics";
import { getSpouse } from "./Spouse";
import { fetchPoe } from "./Poe";
import { clearAllModifiedWindow } from "./ModifiedWindows";
import { getUDWForm } from "./UserDefinedWindow";

const initialData = {
  windowDetails: {},
  saveAllWindosResponse: {},
  windowdetails: {},
  isLoading: false,
  errorMsg: null,
  successMsg: null,
};

const saveAllWindowsSlice = createSlice({
  name: "saveAllWindows",
  initialState: {
    ...initialData,
  },
  reducers: {
    fetchStart: (state) => {
      state.isLoading = true;
      state.successMsg = null;
      state.errorMsg = null;
    },
    fetchWindowDetailsData: (state, action) => {
      state.windowDetails = { ...state.windowDetails, ...action.payload };
      state.isLoading = false;
      state.errorMsg = null;
    },
    saveAllWindowsResponse: (state, action) => {
      state.saveAllWindosResponse = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
    },
    getWindowNameDetails: (state, action) => {
      state.windowdetails = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
    },
    fetchSuccess: (state, action) => {
      state.successMsg = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
    },
    fetchError: (state, action) => {
      state.errorMsg = action.payload;
      state.isLoading = false;
      state.successMsg = null;
    },
    resetMsg: (state) => {
      state.successMsg = null;
      state.errorMsg = null;
      state.isLoading = false;
    },
  },
});

export default saveAllWindowsSlice.reducer;

// Actions

export const {
  fetchWindowDetailsData,
  saveAllWindowsResponse,
  getWindowNameDetails,
  fetchSuccess,
  resetMsg,
  fetchStart,
  fetchError,
} = saveAllWindowsSlice.actions;

export const getWindowdetails = (data) => {
  return (dispatch) => {
    httpPost(`windowdetails/get/reposandfields`, data).then((data) => {
      if (data && data.status && data.status === 200) {
        dispatch(fetchWindowDetailsData(data.response?.fieldMappingResponse));
      }
    });
  };
};

export const getWindowsList = () => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(`windowdetails/get/windows`)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(getWindowNameDetails(data?.response));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};

export const saveAllWindows = (data, {windowName, accountNumber, clientCode}) => {
  return (dispatch, getState) => {

    function fetchCurrTabData(currTab) {
      if (currTab === ACCOUNT_STATUS) {
        dispatch(fetchAccountStatus(accountNumber ));
      }
      if (currTab === IMPORTANT_NOTES) {
        dispatch(getSpecNotes(accountNumber ));
      }
      if (currTab === PATIENT_DEMOGRAPHICS) {
        dispatch(fetchCustomerDemographics(accountNumber));
        dispatch(getSpouse(accountNumber));
        dispatch(fetchPoe(accountNumber));
        dispatch(fetchCommunicationOptOutsData(accountNumber));
      }
    }
    dispatch(fetchStart());
    httpPost(`windowdetails/save/all/windowdata`, data)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(saveAllWindowsResponse(data));
          dispatch(fetchSuccess(data.response));
          fetchCurrTabData(windowName);
          dispatch(clearAllModifiedWindow());
          sessionStorage.removeItem("modifiedWindowsFields");
          const udwData = getState()["userDefinedWindow"]?.["udwData"] || {};
          for (const windowCode in udwData) {
            if (
              windowName === udwData?.[windowCode]?.["window"]?.["windowDescription"]
            ) {
              const payload = {
                accountNumber: accountNumber ? accountNumber : "",
                clientNumber: clientCode ? clientCode : "",
                windowId: windowCode ? windowCode : "",
              };
              dispatch(getUDWForm(payload));
            }
          }
          if (data && data?.data && data?.data?.status === 400) {
            dispatch(fetchError(data?.data.message));
          }
        } else {
          dispatch(fetchError(data.message));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      }).finally(() => {
        setTimeout(() => {
          dispatch(resetMsg());
        }, 4000);
      });
  };
};

export const handleDataReset = () => {
  return (dispatch) => {
    dispatch(resetMsg());
  };
};
